import toArray from '../../../frontend/scripts/utils/to-array';


export default () => {
  const scheduleContainers = toArray(document.querySelectorAll('.js-schedule'));

  if (!scheduleContainers) {
    return;
  }

  scheduleContainers.forEach(scheduleContainer => {

    import('./Schedule' /* webpackChunkName: "schedule" */).then(
      ({ initializeSchedule }) => {
        initializeSchedule(scheduleContainer);
      }
    );
  });
};


